import { makeSupabaseClient } from '@/shared/infra/supabase'
import { SupabaseOnAccessTokenChangeRepository } from '@/modules/auth/infra'
import type { OnAccessTokenChange } from '@/modules/auth/use-cases'

export function makeOnAccessTokenChange(): OnAccessTokenChange {
  return new SupabaseOnAccessTokenChangeRepository(makeSupabaseClient()).execute
}
